import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { Col } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import OperateurGroupeIcon from "../../../components/CustomIcons/OperateurGroupeIcon/OperateurGroupeIcon";
import PosteIcon from "../../../components/CustomIcons/PosteIcon/PosteIcon";

const scanOperateur = ({
  operateur,
  message = "attente scan \nopérateur...",
  icon = <PosteIcon tache="scan_operateur" size={70 + "%"} />,
}) => {
  const dataOperateur = operateur && operateur.data;

  return (
    <AnimatePresence mode="wait">
      {!dataOperateur ? (
        <motion.div
          className="h-100"
          key="defaut"
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.25, ease: [0.17, 0.67, 0.83, 0.67] }}
        >
          <Col
            xs={12}
            className="bg-perform text-black text-uppercase h2 fw-bold rounded justify-content-center align-items-center text-center h-100"
          >
            {icon}
            <div>{message}</div>
          </Col>
        </motion.div>
      ) : (
        <motion.div
          className="h-100"
          key="operateur"
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.25, ease: [0.17, 0.67, 0.83, 0.67] }}
        >
          <Col
            xs={12}
            className="bg-hybride text-black rounded h-100 position-relative"
          >
            <div className="text-uppercase w-100 h3 pt-4 text-center">
              <OperateurGroupeIcon
                idOperateurGroupe={dataOperateur.groupe.id}
                size={4.7}
              />
              <br />
              <br />
              Opérateur scanné
            </div>
            <div className="card h4 m-4 p-3">
              <p>
                {dataOperateur.prenom} {dataOperateur.nom}
              </p>
              <p>Groupe: {dataOperateur.groupe.libelle}</p>
            </div>
            <div className="text-center position-absolute bottom-0 w-100 mb-4">
              <FaCheckCircle size={20 + "%"} />
            </div>
          </Col>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default scanOperateur;
